import React from "react";
import {Grid, Link} from "@material-ui/core";
import LawyerBox from "../lawyerBox/lawyerBox";
import DescriptionBox from "../descriptionBox/descriptionBox";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneInTalkOutlinedIcon from '@material-ui/icons/PhoneInTalkOutlined';
import {connect, MapStateToProps} from "react-redux";


interface OwnProps {
    data: any,
}

interface ConnectStateProps {
    States: any
}

interface Lawyer {
    data: {
        id: number,
        email: string,
        imageUrl: string,
        name: string,
        phone: string,
        proposal: any
    }
}

const MatchedLawyer = (props: any) => {
    const lawyer = props.data,
        caseState = props.caseState;

    const lawyerState = lawyer.States.find((st: any) => st.state === caseState.id);

    if (lawyerState) {
        lawyer.States = [lawyerState]
    }
    lawyer.States = lawyer.States ? lawyer.States.map((st: any) => {
        const state = props.States.find((state: any) => st.state === state.id);
        return {
            ...state,
            ...st
        };
    }) : [];
    return (
        <div className="my-3 my-lg-0 matched-lawyer">
            <Grid container className="mb-3">
                <Grid item xs={12} lg={4} className='d-flex px-1 px-lg-0'>
                    <LawyerBox data={lawyer}/>
                </Grid>
                <Grid item xs={12} lg={7} className='pt-4 pt-lg-0'>
                    <div className='matched-lawyer-buttons'>
                        <Link
                            href={`tel:${lawyer.phone}`}
                            className="mb-3 call-btn">
                            <PhoneInTalkOutlinedIcon/>
                            Call
                        </Link>
                        <Link href={`mailto:${lawyer.email}`}
                            className="mail-btn">
                            <MailOutlineIcon/>
                            Mail
                        </Link>
                    </div>
                </Grid>
                <Grid className='mt-4' item xs={12} lg={11}>
                    <DescriptionBox data={{description: 'Proposal', text: lawyer.comment, date: lawyer.proposal_date, className: 'description-box'}} />
                </Grid>
            </Grid>
        </div>
    )
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {States} = state;
    return {
        States,
    }
};

export default connect(mapStateToProps)(MatchedLawyer);
